import { Component } from "react";
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";

import { Flex } from "../shared";
import { mq } from "../responsive";

export default class Scroll extends Component {
  static Item = ({ children, css }) => (
    <div
      css={{
        minWidth: "fit-content",
        ...css,
      }}
    >
      {children}
    </div>
  );

  render() {
    const {
      gutter: { xs = 24, sm = xs, md = sm, lg = md, xl = lg } = {},
      children,
    } = this.props;
    return (
      <Flex
        css={{
          flexWrap: "nowrap",
          padding: "0 12px",
          overflowY: "visible",
          overflowX: "auto",
          paddingBottom: "3rem",

          "& > div": {
            marginRight: `${xs}px`,

            [mq.sm]: {
              marginRight: `${sm}px`,
            },

            [mq.md]: {
              marginRight: `${md}px`,
            },

            [mq.lg]: {
              marginRight: `${lg}px`,
            },

            [mq.xl]: {
              marginRight: `${xl}px`,
            },
            ...this.props.css,
          },
        }}
      >
        {children}
      </Flex>
    );
  }
}
